module.exports = require("electron-about-window");